import { TimeInput, TimeInputProps } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { TimeInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import FormTextControl from './hoc/FormTextControl';
import { RequiredHistoryProps, withHistory } from './hoc/HistoryContainer';

interface TimeInputControlProps
  extends
    RequiredHistoryProps<HTMLInputElement>,
    Omit<TFormControlConnectorProps, 'onChange' | 'onChanged' | 'onSubmit'>,
    Pick<
      TimeInputProps,
      'className' | 'rounded' | 'onChange' | 'onChanged' | 'onSubmit'
    > {
  control: TimeInputFormControlViewModel;
}

const FormTimeInputControl = ({
  areHintsShown,
  className,
  control,
  rounded,
  onChange,
  onChanged,
  onRef,
  onSubmit,
}: TimeInputControlProps): React.JSX.Element => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <TimeInput
      className={className}
      containerRef={onRef}
      disabled={control.disabled}
      invalid={control.invalid}
      readOnly={control.readonly}
      required={control.required}
      rounded={rounded}
      value={control.value}
      onChange={onChange}
      onChanged={onChanged}
      onSubmit={onSubmit}
    />
  </FormLabeledInputControl>
);

export default withHistory(FormTextControl(FormTimeInputControl));
